export default __webpack_public_path__ + "static/media/Famous_Sitting_Spot_at_Pachmarhi_Lake.d6eafcf4.jpg";